export default __webpack_public_path__ + "assets/images/497839e257e5b060c9a8e4ba13dffb44.svg";